export const colors = {
  whiteLight31: '#FFFFFF31',
  orange: '#FA7B42',
  borderColorLight: '#A2C0D430',
  borderColorLightGray: '#bdc3c7',
  borderColor: '#A2C0D4',
  gray: '#B3B8BB',
  lightGray: '#F3F3F3',
  lightOrange: '#F1F5F8',
  backgroundColor: '#3C3FC1',
  titleTextColor: '#414D55',
  titleDarkTextColor: '#2C3E50',
  red: '#C91432',
  red2: '#DE4A5B',
  activeColor: '#0D8E74',
  green: '#009a7b',
  greenLight: '#0D8E7418',
  screenBackColor: '#FBFBFB',
  primaryLight: '#1989E918',
  purple: '#700FB9',
  blue: '#1475C9',
  lightBlue: '#054A9108',
  darkBlue: '#054A91',
  inactiveColor: '#BEBEBE',
  dialogListBackColor: '#F9F9F9',
  upstreamColor: '#5B5E9F',
  midstreamColor: '#E86A66',
  servicesColor: '#32C7A3',
  lotOfCapacity: '#7376C8',
  anotherProject: '#42C8B2',
  lessProject: '#DBAC5B',
  slammed: '#DE4A5B',
  mutedText: '#CDCDCD',
  lightMutedText: '#959EA7',
  lightText: '#ACACAC',
  darkGray: '#727B80',
  business_1: '#C91432',
  business_2: '#8E0D5A',
  business_3: '#0D8E74',
  business_4: '#F8C257',
  business_5: '#1475C9',

  //  New Colors
  noLoad: '#D3D3D3',
  tooLight: '#5557C9',
  veryLight: '#696AC8',
  perfect: '#32A48D',
  tooBusy: '#F1A56C',
  needHelp: '#DE4A5B',

  primary: 'rgb(11,27,78)',
  primaryMid: 'rgb(78,94,145)',
  primaryMuted: 'rgb(94,108,154)',
  tabBarInactive: 'rgb(11,27,78)',

  // Light Colors
  light01: '#E4E4F6',
  light02: '#DBDBEE',
  light03: '#D0E7E2',
  light04: '#F6E5D8',
  light05: '#F3D5D8',
  light06: '#FCECEE',
  light07: '#EDEEF4',
  light08: '#FEF5EE',
  light09: '#EAF6F3',

  light_grey: '#F7F7F7',

  // Project Status
  inactiveProjectColor: '#4E5E91',
  inactiveTextColor: '#828CB0',

  //Typography
  textColor: '#0B1B4E',
  seeAll: '#5557C9',
  containedText: '#E4E4F2',

  //Borders
  borderColor_1: '#F1F1F8',
  borderColor_2: '#D3D6DC',
  borderColor_3: '#E0E7F3',
  borderColor_4: '#5E6C9A',
  borderColor_5: 'rgba(1, 31, 83, 0.2)',
  borderColor_6: 'rgb(200,206,216)',
  borderColor_7: 'rgb(231,231,231)',
  borderColor_7A: 'rgb(239,239,239)',
  borderColor_8: 'rgb(247,247,247)',
  borderColor_light: 'rgb(224,231,243)',
  borderColor_BTN: 'rgb(199,205,215)',

  // Shadows
  shadow_color: 'rgba(20,46,110,0.1)',
  shadow_1: 'rgb(239,239,239)',
  borderColor_9: 'rgb(228,228,242)',

  // Input
  input_border: 'rgb(183,189,199)',
  // Staffing Status Bg

  staffingStatus_01: '#EAEAFC',
  staffingStatus_02: '#E1E1F4',
  staffingStatus_03: '#D6EDE8',
  staffingStatus_04: '#FCEBDE',
  staffingStatus_05: '#F9DBDE',

  primaryTextColor: '#0B1B4E',
  mutedTextColor: '#4E5E91',
  mutedPurple: 'rgba(228,228,242,0.5)',
  mutedBorderColor: 'rgba(78,94,145,0.25)',
  primaryActionColor: '#5557C9',
  inputBorderColor: '#B7BDC7',
  primaryMutedColor: '#E7E7F8',

  //! APP
  generalBg: '#FBFBFB',
  appBg: '#F7F7F7',
  dropShadowColor: 'rgba(20,46,110,0.10)',
  midBlue: '#E3E9F4',

  // ? common APP colors
  teamcap_red: 'rgb(222,74,91)',
  teamcap_red_light: 'rgba(222,74,91,0.15)',

  //? header
  headerBorderColor: 'rgba(112,112,112,0.25)',

  //* common
  white: '#ffffff',
  black: '#000000',
  transparent: 'transparent',
  pillBg: '#C5C8D320',
};

export default colors;
